<div class="ion-margin ion-padding ion-text-center">
  <ion-icon *ngIf="!!icon" [name]="icon" color="medium" size="large"></ion-icon>
  <h3 *ngIf="!!title" class="ion-margin"><ion-text color="medium">{{ title | translate }}</ion-text></h3>
  <ng-content></ng-content>
</div>
